import { RouteBadge, SupSinglePreparedRoute } from "@/components/Web3/Common/Route/utils/prepareProviderRoutes";

export default function sortProcessedProviderRoutes(providerRoutes: SupSinglePreparedRoute[]): SupSinglePreparedRoute[] {
  // let cheapestRoute = 0;
  // let fastestRoute = 0;
  let highestReturnRoute = 0;
  providerRoutes.forEach((route, index) => {
    if (
      route.toAmountInUsd - route.fees.gasCost - route.fees.crossChainFee >
      providerRoutes[highestReturnRoute].toAmountInUsd - providerRoutes[highestReturnRoute].fees.gasCost - providerRoutes[highestReturnRoute].fees.crossChainFee
    ) {
      highestReturnRoute = index;
    }
  });
  return providerRoutes.map((route, index) => {
    const badges = [] as RouteBadge[];
    /* if (index === cheapestRoute) {
     badges.push("gas");
     }
     if (index === fastestRoute) {
     badges.push("time");
     } */
    if (index === highestReturnRoute) {
      badges.push("output");
    }
    return {
      ...route,
      badges,
    } as SupSinglePreparedRoute;
  });
}
